import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetMasterRater {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
}

export const getMasterRater = ({
  search = '',
  page,
  size,
  scheduleid = '',
  userin = ''
}: GetMasterRater) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.masterRater.getList
    }?search=${search}&page=${page}&scheduleid=${scheduleid}&userin=${
      userin || ''
    }`
  );
};

export const postMasterRater = (data) => {
  return HttpService.post(ApiService.icdc.module.masterRater.add, data);
};

export const editMasterRater = (data) => {
  return HttpService.post(ApiService.icdc.module.masterRater.update, data);
};

export const editPositionMasterRater = (data) => {
  return HttpService.post(
    ApiService.icdc.module.masterRater.updatePosition,
    data
  );
};

export const deleteMasterRater = (data) => {
  return HttpService.post(ApiService.icdc.module.masterRater.delete, data);
};
